// Маппинг полей Bitrix24 с их человекочитаемыми названиями

export const FIELD_MAPPING = {
  // Стандартные поля
  'id': 'ID заказа',
  'title': 'Название заказа',
  'stageId': 'Стадия',
  'createdTime': 'Дата создания',
  'updatedTime': 'Дата обновления',
  'assignedById': 'Ответственный (ID)',
  'opportunity': 'Сумма',
  'companyId': 'Компания (ID)',
  'contactId': 'Контакт (ID)',
  'createdBy': 'Создал (ID)',
  'currentStage': 'Текущая стадия',
  'orderNumber': 'Номер заказа (обработанный)',

  // Пользовательские поля
  'ufCrm3_1746789101': 'Номер заказа',
  'ufCrm3_1746789363': 'Товары',
  'ufCrm3_1746789446': 'ID-B2C',
  'ufCrm3_1746789468': 'ID-B2B',
  'ufCrm3_1746789474': 'ID-Франчайзи',
  'ufCrm3_1746789572': 'Триггер: Матовка',
  'ufCrm3_1746789589': 'Триггер: упаковка',
  'ufCrm3_1746789599': 'Триггер: Фурнитура',
  'ufCrm3_1746789627': 'Триггер: Закалка',
  'ufCrm3_1746789650': 'Триггер: LOFT / Зеркало',
  'ufCrm3_1746789862': 'Файл договора',
  'ufCrm3_1746789890': 'Дизайн чертежа',
  'ufCrm3_1746789910': 'Деталировка чертежа',
  'ufCrm3_1746790033': 'Данные по замеру',
  'ufCrm3_1746790136': 'Чертеж "загрузите старый чертеж до переделки"',
  'ufCrm3_1746790327': 'Ответственный за чертеж',
  'ufCrm3_1746790893': 'Ответственный за замер',
  'ufCrm3_1746791181': 'Ответственный за фурнитуру',
  'ufCrm3_1747750785257': 'Триггер: Сырое стекло',
  'ufCrm3_1749212561933': 'Ответственный за обработку и сверловку стекла',
  'ufCrm3_1749212579499': 'Ответственный за резку стекла',
  'ufCrm3_1749212591302': 'Ответственный за матировку стекла',
  'ufCrm3_1749212635898': 'Ответственный за сборку лофта и зеркала',
  'ufCrm3_1749212685683': 'Ответственный за сборку фурнитуры',
  'ufCrm3_1749212694990': 'Ответственный за упаковку',
  'ufCrm3_1749212719306': 'Ответственный за закалку',
  'ufCrm3_1749212970874': 'Источник стекла душевой перегородки (Поставщик стекла)',
  'ufCrm3_1749212997464': 'Источник стекла LOFT перегородки (Поставщик стекла)',
  'ufCrm3_1749213049974': 'Ответственный за установку (ФИО, телефон)',
  'ufCrm3_1749213064008': 'Ответственный за отправку',
  'ufCrm3_1749213221666': 'Накладной документ от службы доставки',
  'ufCrm3_1749213244986': 'Дата передачи заказа в службу доставки',
  'ufCrm3_1749213340553': 'Данные по установке (фото и видео)',
  'ufCrm3_1749213350972': 'Дата завершения установки',
  'ufCrm3_1749213376934': 'Документ: АВР (акт выполненных работ)',
  'ufCrm3_1749475648149': 'Данные по упаковке (фото и видео)',
  'ufCrm3_1749555592378': 'Дата завершения упаковки',
  'ufCrm3_1751274844238': 'Прозрачный 8 мм.',
  'ufCrm3_1751274861103': 'Бронза 8 мм.',
  'ufCrm3_1751275030885': 'Прозрачный 4 мм.',
  'ufCrm3_1751275041994': 'Бронза 4 мм.',
  'ufCrm3_1751275363654': 'Прозрачный 6 мм.',
  'ufCrm3_1751275374960': 'Прозрачный 10 мм.',
  'ufCrm3_1751279653655': 'Графит 8 мм.',
  'ufCrm3_1751344784096': 'Резка запись для Лютер',
  'ufCrm3_1751344871698': 'Итог Резка',
  'ufCrm3_1751344928901': 'Резка коментарии',
  'ufCrm3_1751370238766': 'Сверловка запись для Лютер',
  'ufCrm3_1751370309345': 'Сверловка коментарии',
  'ufCrm3_1751370446708': 'Сверловка итог',
  'ufCrm3_1751456530577': 'Сверловка коментарии',
  'ufCrm3_1751521756206': 'Закалка запись для Лютер',
  'ufCrm3_1751521814271': 'Отчет для закалки',
  'ufCrm3_1751521846111': 'Коментарий закалка',
  'ufCrm3_1752035088903': 'Матовка Запись для Лютер',
  'ufCrm3_1752035158464': 'Матировка отчет',
  'ufCrm3_1752035904757': 'Коментариий Матовка',
  'ufCrm3_1752122668020': 'Отчет о переделке',
  'ufCrm3_1752145786785': 'Ответсвенный за сборку лофта/зеркало',
  'ufCrm3_1752145842832': 'Ответственный за фурнитуру',
  'ufCrm3_1752165266': 'Графит 4 мм.',
  'ufCrm3_1752818210443': 'Закалка прием запись JSON',
  'ufCrm3_1752818233225': 'Отчет о приеме закалки',
  'ufCrm3_1752818259434': 'Коментарий прием закалка',
  'ufCrm3_1753076476775': 'Адрес заказа',
  'ufCrm3_1753263371950': 'Записаны ли деталировки стекол для производства?',
  'ufCrm3_1753795707997': 'Файл фурнитуры',
  'ufCrm3_1753799333731': 'Триггер: Переделка',
  'ufCrm3_1753799343825': 'Триггер: Бой на закалке',
  'ufCrm3_1753862276063': 'Статус фурнитуры',
  'ufCrm3_1754027253985': 'Графит 6 мм.',
  'ufCrm3_1754027309932': 'Бронза 6 мм.',
  'ufCrm3_1754027324300': 'Бронза 10 мм.',
  'ufCrm3_1754027335383': 'Графит 10 мм.',
  'ufCrm3_1754046893462': 'Лофт файл и фидео',
  'ufCrm3_1755579125099': 'Комментарий для чертежника',
  'ufCrm3_1755579396141': 'Комментарий по доработке чертежа',
  'ufCrm3_1757005830': 'Выдача фото и видео',
  'ufCrm3_1757404689894': 'Таймлайн цеха',

  // Временные метрики (вычисляемые поля)
  '_totalProductionTime': 'Общее время производства',
  '_time_резка_стекла': 'Время на резке стекла',
  '_time_обработка_стекла': 'Время на обработке стекла',
  '_time_готово_к_закалке': 'Время: готово к закалке',
  '_time_стекло_на_закалке': 'Время на закалке',
  '_time_матировка': 'Время на матировке',
  '_time_упаковка': 'Время на упаковке',
  '_time_комплектация': 'Время на комплектации',
  '_time_готово_к_доставке': 'Время: готово к доставке',
  '_time_готово_к_выдаче': 'Время: готово к выдаче'
};

/**
 * Получить человекочитаемое название поля
 */
export const getFieldDisplayName = (fieldId) => {
  return FIELD_MAPPING[fieldId] || fieldId;
};

/**
 * Получить все доступные поля с их названиями
 */
export const getAllFields = () => {
  return Object.entries(FIELD_MAPPING).map(([id, name]) => ({
    id,
    name,
    displayName: name
  }));
};

/**
 * Получить поля, отсортированные по названию
 */
export const getSortedFields = () => {
  return getAllFields().sort((a, b) => a.name.localeCompare(b.name, 'ru'));
};

/**
 * Получить поля для конкретного типа (строка, дата, файл и т.д.)
 */
export const getFieldsByType = (type) => {
  // Можно расширить логику для определения типов полей
  const dateFields = [
    'createdTime', 'updatedTime',
    'ufCrm3_1749213244986', 'ufCrm3_1749213350972', 'ufCrm3_1749555592378'
  ];

  const fileFields = [
    'ufCrm3_1746789862', 'ufCrm3_1746789890', 'ufCrm3_1746789910',
    'ufCrm3_1746790033', 'ufCrm3_1746790136', 'ufCrm3_1749213221666',
    'ufCrm3_1749213340553', 'ufCrm3_1749213376934', 'ufCrm3_1749475648149',
    'ufCrm3_1753795707997', 'ufCrm3_1754046893462', 'ufCrm3_1757005830'
  ];

  const numberFields = [
    'id', 'assignedById', 'opportunity', 'companyId', 'contactId', 'createdBy'
  ];

  switch (type) {
    case 'date':
      return getAllFields().filter(field => dateFields.includes(field.id));
    case 'file':
      return getAllFields().filter(field => fileFields.includes(field.id));
    case 'number':
      return getAllFields().filter(field => numberFields.includes(field.id));
    case 'string':
    default:
      return getAllFields().filter(field =>
        !dateFields.includes(field.id) &&
        !fileFields.includes(field.id) &&
        !numberFields.includes(field.id)
      );
  }
};

/**
 * Поиск полей по названию
 */
export const searchFields = (query) => {
  if (!query) return getSortedFields();

  const lowercaseQuery = query.toLowerCase();
  return getSortedFields().filter(field =>
    field.name.toLowerCase().includes(lowercaseQuery) ||
    field.id.toLowerCase().includes(lowercaseQuery)
  );
};